<template>
  <div class="index-recommend container" v-if="recommend_list.length > 0">
    <div class="container-head">
      <div class="head-left">
        <div class="icon">
          <img src="../../static/index/recommend/recommend-icon.png" />
        </div>
        推荐专区
      </div>
      <!-- <div class="head-right">
        查看更多
        <div class="icon"></div>
      </div> -->
    </div>
    <div class="recommend-list">
      <div class="swiper_list container-build">
        <div class="swiper-container tuijian">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in recommend_list"
              :key="index"
            >
              <div class="row">
                <div
                  class="col-lg-3 col-md-3 col-sm-6 col-xs-6"
                  v-for="(item, i) in item"
                  @click="goproductDetail(item.id)"
                >
                  <div
                    class="recommend-item"
                    :class="['recommend-item-' + (i + 1)]"
                  >
                    <div class="item-title-1">{{ item.title }}</div>
                    <div class="item-title-2">{{ item.subtitle }}</div>
                    <div class="item-price-button">
                      <div class="item-price">
                        <span>￥</span>{{ item.show_price }}
                      </div>
                      <div class="item-button">点击查看</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination"></div>
          <!-- 如果需要滚动条 -->
          <!--    <div class="swiper-scrollbar"></div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["recommend_list"],
  data() {
    return {};
  },
  methods: {
    goproductDetail(id) {
      this.$router.push({
        path: "productdetail",
        query: {
          id: id
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.index-recommend {
  flex-direction: column;
  margin: auto;

  .recommend-list {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    .row {
      //   margin: 0;

      .recommend-item {
        background: url(../../static/index/recommend/recommend-item-bg-1.png)
          bottom right no-repeat;
        background-size: cover;
        flex-direction: column;
        padding: 0.2rem 0.2rem;
        margin-bottom: 0.2rem;
        height: auto;
        display: flex;
        justify-content: flex-start;
        text-align: left;
        border: 0.01rem solid #1395ff;
        //box-shadow: 0px 0.01rem 0.05rem 0px #1395ff;
        border-radius: 0.12rem;
        width: 100%;
        cursor: pointer;
        .item-title-1 {
          font-size: 0.24rem;
          line-height: 0.33rem;
          color: #1b1c33;
          font-weight: 500;
          margin-bottom: 0.15rem;
          overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
        }

        .item-title-2 {
          font-size: 0.18rem;
          color: #5e5e66;
          line-height: 0.25rem;
          margin-bottom: 0.49rem;
        }

        .item-price-button {
          justify-content: space-between;
          align-items: center;
          display: flex;
          .item-price {
            font-size: 0.3rem;
            color: #ff545a;
            line-height: 0.6rem;
            font-weight: 500;

            span {
              font-size: 0.2rem;
              line-height: 0.6rem;
            }
          }

          .item-button {
            width: 1.2rem;
            height: 0.36rem;
            font-size: 0.18rem;
            line-height: 0.36rem;
            background-color: #1395ff;
            border-radius: 0.18rem;
            color: #ffffff;
            text-align: center;
            justify-content: center;
          }
        }
      }

      .recommend-item-2 {
        background: url(../../static/index/recommend/recommend-item-bg-2.png)
          bottom right no-repeat;
        background-size: cover;
        border: 0.01rem solid #ff9f35;
        //box-shadow: 0px 0.01rem 0.05rem 0px #ff9f35;
        .item-price-button {
          .item-button {
            background-color: #ff9f35;
          }
        }
      }
      .recommend-item-3 {
        background: url(../../static/index/recommend/recommend-item-bg-3.png)
          bottom right no-repeat;
        background-size: cover;
        border: 0.01rem solid #18e0ac;
        //box-shadow: 0px 0.01rem 0.05rem 0px #18e0ac;
        .item-price-button {
          .item-button {
            background-color: #18e0ac;
          }
        }
      }
      .recommend-item-4 {
        background: url(../../static/index/recommend/recommend-item-bg-4.png)
          bottom right no-repeat;
        background-size: cover;
        border: 0.01rem solid #ff656a;
        //box-shadow: 0px 0.01rem 0.05rem 0px #ff656a;
        .item-price-button {
          .item-button {
            background-color: #ff656a;
          }
        }
      }

      @media (max-width: 991px) {
        .col-xs-6 {
          //padding: 0 0.15rem;
        }
        .recommend-item {
          margin-bottom: 0.2rem;
          .item-title-1 {
            font-size: 0.28rem;
            line-height: 0.36rem;
            height: 0.36rem;
            color: #1b1c33;
            font-weight: bolder;
          }

          .item-title-2 {
            font-size: 0.26rem;
            color: #5e5e66;
            line-height: 0.3rem;
            height: 0.3rem;
            margin-bottom: 0.24rem;
          }

          .item-price-button {
            justify-content: space-between;
            align-items: center;

            .item-price {
              font-size: 0.48rem;
              color: #ff545a;
              line-height: 0.48rem;
              font-weight: bolder;

              text {
                font-size: 0.3rem;
                line-height: 0.6rem;
              }
            }

            .item-button {
              width: 1.26rem;
              height: 0.4rem;
              font-size: 0.24rem;
              line-height: 0.4rem;
              background-color: #1395ff;
              border-radius: 0.2rem;
              color: #ffffff;
              text-align: center;
              justify-content: center;
            }
          }
        }
      }
    }
  }
}
[class*="col-"] {
  padding: 0 0.1rem;
}
.row {
  margin: 0rem;
}
</style>



// WEBPACK FOOTER //
// src/components/indexrecommend.vue